module.exports = __webpack_public_path__ + "img/320.61baece0.jpg";